import { useErrorNotificationApi } from '@equifinance/shared';
import { AuditHistory } from '../contexts/audit/Audit';
import { DocumentType } from './useDocumentsApi';

const apiPath = `${process.env.REACT_APP_ORIGINATION_API_PATH}/`;

const apiUrl = (path: string) => `${apiPath}${path}`;

type AuditDocument = {
  fileName: string,
  documentType: DocumentType.PDF,
  documentData: string,
};

export type AuditApiType = {
  getAuditHistory: (applicationId: string) => Promise<AuditHistory>,
  getAuditHistoryDocument: (applicationId: string) => Promise<AuditDocument>,
}

const useAuditApi = (): AuditApiType => {
  const {
    get,
  } = useErrorNotificationApi(apiUrl);
  return {
    getAuditHistory: (applicationId: string): Promise<AuditHistory> => get(`audit/${applicationId}`),
    getAuditHistoryDocument: (applicationId: string): Promise<AuditDocument> => get(`audit/${applicationId}/documents/audit-history`),
  };
};

export default useAuditApi;
